import React from "react";
import {Helmet} from "react-helmet";
// import {injectShopContainer} from '../../react/ShopDataContainer'


export default class Base extends React.Component {
  render () {
    // console.log('hi', shop)
    let name = "Shiso Sushi Bar"
    let description = "Shiso Sushi Bar brings bold, modern sushi to Los Angeles with two locations in North Hollywood and Sherman Oaks. Fresh ingredients, creative rolls, and a welcoming vibe—experience Shiso today."
    return (
      <Helmet>
          <meta charSet="utf-8" />
          <title>{name}</title>
          <meta name="description"
            content={description} />
          <link rel="canonical" href="https://shisosushibar.com" />

          <link rel="manifest" href={`${process.env.PUBLIC_URL}/shiso.json`} />
          <link rel="apple-touch-icon" sizes="250x250"
            href={`${process.env.PUBLIC_URL}/shiso.png`} />
          <link rel="apple-touch-icon" sizes="250x250"
            href={`${process.env.PUBLIC_URL}/shiso.png`} />
          <link rel="shortcut icon"
            href={`${process.env.PUBLIC_URL}/shiso.png`}
          />

          {/* Open Graph */}
          <meta property="og:title" content={name} />
          <meta property="og:site_name" content={name} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content="https://plus.unsplash.com/premium_photo-1723874570807-570c56b41e4e?q=80&w=3870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />

          {/* <meta property="og:image" content={} /> */}
          {/* <meta property="og:url" content="http://euro-travel-example.com/index.htm" /> */}
      </Helmet>


    );
  }
};

// export default injectShopContainer(Base)
